// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"jd","image":"je","contentContainer":"jf","mainText":"jh","subText":"ji","counter":"jj"};